import { ReferenceDataTypes } from "@enums/reference-data-types";
import { CommonReferenceData } from "@idw-types/state/common-reference-data-state";
import { getCommonReferenceDataState } from "@redux/selectors/root-selectors";
import { getReferenceData } from "@utils/reference-data-util";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useReferenceDataSelector = <T = CommonReferenceData>(referenceDataTypes: Array<ReferenceDataTypes>, includeAxnRPServices?: boolean) => {
    const commonReferenceData = useSelector(getCommonReferenceDataState);

    return useMemo(() => {
        const result = getReferenceData<T>(referenceDataTypes, commonReferenceData);

        if (includeAxnRPServices) {
            //@ts-ignore
            result["axnRPServices"] = commonReferenceData.axnRPServices;
        }
        return result;
    }, [commonReferenceData]);
};